import React from 'react';
import { AritoHeaderTabs, AritoIcon, BottomActionBarV2, AritoDialog, AritoForm } from '@/components/custom/erp';
import { initialSearchParams, searchSchema } from '../../schemas';
import DetailsTab from './DetailsTab';
import FilterTab from './FilterTab';
import BasicInfo from './BasicInfo';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: any) => void;
  searchFieldStates: any;
}

export const SearchDialog: React.FC<SearchDialogProps> = ({ open, onClose, onSearch, searchFieldStates }) => {
  const handleSubmit = (data: any) => {
    onSearch({
      ngay_ct1: data.ngay_ct1,
      ngay_ct2: data.ngay_ct2,
      so_ct1: data.so_ct1,
      so_ct2: data.so_ct2,
      dien_giai: data.dien_giai,
      tk: searchFieldStates.account?.uuid,
      ma_kh: searchFieldStates.customer?.uuid,
      ma_unit: searchFieldStates.unit?.uuid,
      status: data.status === 'ALL' ? '' : data.status,
      user_id: data.user_id0 === 'ALL' ? '' : data.user_id0
    });
    onClose();
  };

  return (
    <AritoDialog
      open={open}
      onClose={onClose}
      title='Lọc chứng từ'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoForm
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialSearchParams}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[1000px] overflow-y-auto'>
            <BasicInfo />

            <AritoHeaderTabs
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: (
                    <DetailsTab
                      searchFieldStates={{
                        customer: searchFieldStates.customer,
                        setCustomer: searchFieldStates.setCustomer,
                        account: searchFieldStates.account,
                        setAccount: searchFieldStates.setAccount
                      }}
                    />
                  )
                }
              ]}
              className='border-b border-b-gray-200'
            />

            <FilterTab searchFieldStates={searchFieldStates} />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
      />
    </AritoDialog>
  );
};

export default SearchDialog;
